import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";

const MobileSearch = () => {
  const [searchValue, setSearchValue] = useState()
    const history = useHistory()
  const topSearchHandle = (e) => {
    e.preventDefault()
    history.push(`/shop?s=${searchValue ?? ''}`)
  }

  return (
    <div className="offcanvas-mobile-search-area">
      <form onSubmit={topSearchHandle}>
        <input placeholder="Search ..." onChange={(e) => setSearchValue(e.target.value)} />
        <button type="submit">
          <i className="fa fa-search" />
        </button>
      </form>
    </div>
  );
};

export default MobileSearch;